// Centralny indeks Bazy wiedzy. Dodanie artykułu = wrzucenie pliku .md do
// public/knowledge-base/<kategoria>/<slug>.md + jeden wpis poniżej.
// related: element to slug istniejącego artykułu (link) albo { title } = pozycja „w przygotowaniu".

export const KB_CATEGORIES = [
  { key: 'falowniki', label: 'Falowniki', description: 'Dobór mocy, liczby faz, liczby MPPT i typu falownika.' },
  { key: 'pv', label: 'Moduły fotowoltaiczne', description: 'Cena za Wp, sprawność, gwarancje i parametry modułów.' },
  { key: 'magazyny', label: 'Magazyny energii', description: 'Pojemność, moc, tryby pracy i dobór magazynu.' },
  { key: 'instalacje-pv', label: 'Instalacje PV', description: 'Oferty, wykonawcy, formalności i finansowanie całej instalacji.' },
  { key: 'ladowarki-ev', label: 'Ładowarki EV', description: 'Dobór wallboxa: moc, liczba faz, ładowanie z fotowoltaiki i wybór do modelu auta.' },
]

const REL_PRODUCTS = {
  all: { label: 'Przeglądaj falowniki', to: '/inwertery' },
  items: [
    { label: 'Falowniki 1-fazowe do 3,68 kW', to: null },
    { label: 'Falowniki 3-fazowe', to: null },
    { label: 'Falowniki z co najmniej 2 MPPT', to: null },
  ],
}

const REL_PANELS = {
  all: { label: 'Przeglądaj moduły PV', to: '/panele' },
  items: [
    { label: 'Moduły 400–500 Wp', to: null },
    { label: 'Moduły bifacjalne', to: null },
    { label: 'Moduły Full Black', to: null },
  ],
}

const REL_WALLBOX = {
  all: { label: 'Przeglądaj ładowarki EV', to: '/ladowarki' },
  items: [
    { label: 'Wallboxy 11 kW 3-fazowe', to: null },
    { label: 'Wallboxy 22 kW', to: null },
    { label: 'Wallboxy 1-fazowe 7,4 kW', to: null },
  ],
}

const REL_STORAGE = {
  all: { label: 'Przeglądaj magazyny energii', to: '/magazyny' },
  items: [
    { label: 'Magazyny od 10 kWh (próg programu PME2)', to: null },
    { label: 'Magazyny wysokonapięciowe', to: null },
    { label: 'Magazyny niskonapięciowe', to: null },
  ],
}

export const KB_ARTICLES = [
  {
    slug: 'falownik-1-fazowy-czy-3-fazowy',
    title: 'Falownik 1-fazowy czy 3-fazowy? Dobór do przyłącza i mocy instalacji PV',
    seoTitle: 'Falownik 1-fazowy czy 3-fazowy? Granica 3,68 kW',
    seoDescription: 'Powyżej 3,68 kW instalację PV przyłącza się trójfazowo. Kiedy wystarczy falownik 1-fazowy, co zmienia rodzaj przyłącza, asymetria faz i liczba MPPT.',
    category: 'falowniki',
    breadcrumbTopic: 'Dobór falownika',
    lead: 'Kiedy wybrać falownik 1-fazowy, a kiedy 3-fazowy: rola przyłącza, mocy instalacji, granicy 3,68 kW, asymetrii faz i liczby MPPT.',
    updatedAt: '2026-07-11',
    readingTime: 9,
    featured: true,
    status: 'published',
    cover: 'phase',
    hero: { subtitle: 'Falownik 1-fazowy vs 3-fazowy · granica 3,68 kW', value: '3,68', unit: 'kW' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/falowniki/falownik-1-fazowy-czy-3-fazowy.md`,
    related: [
      'ile-paneli-na-falownik-przewymiarowanie',
      'falownik-1-fazowy-przy-przylaczu-3-fazowym',
      'jak-dobrac-magazyn-energii-do-fotowoltaiki',
      { title: 'Ile MPPT powinien mieć falownik?' },
      { title: 'Dlaczego falownik wyłącza się przy wysokim napięciu?' },
    ],
    relatedProducts: REL_PRODUCTS,
  },
  {
    slug: 'falownik-1-fazowy-przy-przylaczu-3-fazowym',
    title: 'Falownik 1-fazowy przy przyłączu 3-fazowym: bilansowanie międzyfazowe i kilka falowników',
    seoTitle: 'Falownik 1-fazowy przy 3 fazach: bilansowanie faz',
    seoDescription: 'Falownik 1-fazowy przy przyłączu 3-fazowym działa zwykle do 3,68 kW. Jak bilansowanie międzyfazowe rozlicza energię i kiedy kilka falowników ma sens.',
    category: 'falowniki',
    breadcrumbTopic: 'Dobór falownika',
    lead: 'Fizyczny przepływ, pomiar i bilansowanie międzyfazowe w rozliczeniu prosumenckim oraz kiedy kilka falowników 1-fazowych ma sens.',
    updatedAt: '2026-07-11',
    readingTime: 11,
    featured: false,
    status: 'published',
    cover: 'balancing',
    hero: { subtitle: 'Falownik 1-fazowy vs 3-fazowy · granica 3,68 kW', value: '3,68', unit: 'kW' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/falowniki/falownik-1-fazowy-przy-przylaczu-3-fazowym.md`,
    related: [
      'falownik-1-fazowy-czy-3-fazowy',
      { title: 'Ile MPPT powinien mieć falownik?' },
    ],
    relatedProducts: REL_PRODUCTS,
  },
  // ===== Dobór elektryczny: stringi i falownik (klaster SEO 9f, 2026-10-14) =====
  {
    slug: 'ile-paneli-w-stringu',
    title: 'Ile paneli w stringu? Jak obliczyć minimum i maksimum dla falownika',
    seoTitle: 'Ile paneli w stringu? Minimum i maksimum',
    seoDescription: 'Moduł 460 W i falownik 10 kW z limitem 1100 V: od 6 do 24 paneli w stringu. Maksimum z Voc w −25 °C, minimum z Vmp w 70 °C, potem prąd MPPT.',
    category: 'falowniki',
    breadcrumbTopic: 'Dobór elektryczny',
    lead: 'Liczbę modułów w stringu wyznacza Voc w mrozie (maksimum) i Vmp w upale (minimum). Dla modułu 460 W i falownika 10 kW wychodzi od 6 do 24 sztuk w łańcuchu.',
    updatedAt: '2026-10-14',
    readingTime: 11,
    featured: false,
    status: 'published',
    cover: 'string',
    hero: { subtitle: 'Moduły w jednym łańcuchu: JA Solar 460 W i falownik 10 kW (1100 V)', value: '6 do 24', unit: 'modułów' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/falowniki/ile-paneli-w-stringu.md`,
    related: [
      'ile-paneli-na-falownik-przewymiarowanie',
      'dwa-stringi-na-jednym-mppt',
      'falownik-1-fazowy-czy-3-fazowy',
      'jak-dobrac-panel-fotowoltaiczny-do-rozbudowy-instalacji',
    ],
  },
  {
    slug: 'ile-paneli-na-falownik-przewymiarowanie',
    title: 'Ile paneli na falownik? Przewymiarowanie DC/AC na przykładzie falownika 10 kW',
    seoTitle: 'Ile paneli na falownik? DC/AC i przykład 10 kW',
    seoDescription: 'Na falownik 10 kW: 16 do 30 modułów 500 W, zwykle 22 (DC/AC 1,1). Liczymy łańcuchy na mróz i upał oraz straty przewymiarowania z symulacji PVGIS.',
    category: 'falowniki',
    breadcrumbTopic: 'Dobór elektryczny',
    lead: 'Na falownik podłącza się od 0,8 do 1,5 kWp modułów na 1 kW mocy AC. Przy 10 kW i modułach 500 W typowy dobór to 22 moduły w dwóch łańcuchach po 11.',
    updatedAt: '2026-10-14',
    readingTime: 11,
    featured: false,
    status: 'published',
    cover: 'string',
    hero: { subtitle: 'Moduły 500 W na falownik 10 kW, dwa łańcuchy po 11', value: '22', unit: 'szt.' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/falowniki/ile-paneli-na-falownik-przewymiarowanie.md`,
    related: [
      'ile-paneli-w-stringu',
      'dwa-stringi-na-jednym-mppt',
      'falownik-1-fazowy-czy-3-fazowy',
      'jak-porownac-oferty-na-instalacje-pv',
    ],
  },
  {
    slug: 'dwa-stringi-na-jednym-mppt',
    title: 'Dwa stringi do jednego MPPT: kiedy można i jak policzyć prąd',
    seoTitle: 'Dwa stringi do jednego MPPT: warunki i rachunek',
    seoDescription: 'Dwa stringi na jednym MPPT działają, gdy mają tę samą liczbę modułów. Prądy się sumują: 2 × 13,34 A musi zmieścić się w limicie wejścia.',
    category: 'falowniki',
    breadcrumbTopic: 'Dobór elektryczny',
    lead: 'Dwa łańcuchy na jednym MPPT muszą mieć tę samą liczbę modułów tego samego modelu, bo pracują na wspólnym napięciu. Prądy się sumują, więc liczymy je wobec dwóch limitów wejścia: prądu roboczego i prądu zwarciowego.',
    updatedAt: '2026-10-14',
    readingTime: 10,
    featured: false,
    status: 'published',
    cover: 'string',
    hero: { subtitle: 'Prąd dwóch łańcuchów modułów 440 W na jednym MPPT', value: '26,68', unit: 'A' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/falowniki/dwa-stringi-na-jednym-mppt.md`,
    related: [
      'ile-paneli-w-stringu',
      'ile-paneli-na-falownik-przewymiarowanie',
      'czy-mozna-mieszac-rozne-modele-paneli-fotowoltaicznych',
      'jak-dobrac-panel-fotowoltaiczny-do-rozbudowy-instalacji',
    ],
  },
  {
    slug: 'gwarancja-rekojmia-fotowoltaika-magazyn',
    title: 'Gwarancja i rękojmia przy fotowoltaice i magazynie: kto płaci, gdy coś się zepsuje',
    seoTitle: 'Gwarancja i rękojmia w fotowoltaice: kto płaci',
    seoDescription: 'Przez 2 lata za wadę odpowiada sprzedawca, także za demontaż i montaż. Gwarancja producenta działa osobno. Co z upadkiem firmy, serwis i limity cykli.',
    category: 'instalacje-pv',
    breadcrumbTopic: 'Zakup instalacji',
    lead: 'Kogo reklamować w pierwszych 2 latach, co obejmuje gwarancja producenta i co zrobić, gdy firma upadnie. Fakty i mity, warunki Deye, Hoymiles, Dyness i Sigenergy.',
    updatedAt: '2026-11-02',
    readingTime: 9,
    featured: false,
    status: 'published',
    cover: 'offers',
    hero: { subtitle: 'Demontaż i montaż na koszt sprzedawcy przez', value: '2', unit: 'lata' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/instalacje-pv/gwarancja-rekojmia-fotowoltaika-magazyn.md`,
    related: [
      'oferta-fotowoltaika-z-magazynem-co-sprawdzic',
      'jak-porownac-oferty-na-instalacje-pv',
      'rozbudowa-magazynu-energii',
      'czy-magazyn-energii-sie-oplaca',
    ],
  },
  {
    slug: 'jak-porownac-oferty-na-instalacje-pv',
    title: 'Jak porównać oferty na instalację PV? Na co patrzeć poza ceną',
    seoTitle: 'Jak porównać oferty PV: gwarancje i czerwone flagi',
    seoDescription: 'Najtańsza oferta bywa najgorsza. Jak czytać 4 poziomy gwarancji, sprawdzić, kto montuje, wyłapać czerwone flagi i porównać oferty w gotowej tabeli.',
    category: 'instalacje-pv',
    breadcrumbTopic: 'Zakup instalacji',
    lead: 'Na co patrzeć w ofercie na instalację PV poza ceną: kiedy oferta jest zawyżona, modele sprzętu, hierarchia gwarancji (montaż, magazyn, falownik, moduły), uprawnienia wykonawcy i formalności.',
    updatedAt: '2026-10-14',
    readingTime: 17,
    featured: false,
    status: 'published',
    cover: 'offers',
    hero: { subtitle: 'Hierarchia gwarancji · najważniejsza jest ta na montaż, nie na sprzęt', value: '4', unit: 'poziomy' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/instalacje-pv/jak-porownac-oferty-na-instalacje-pv.md`,
    related: [
      'cena-fotowoltaiki-za-kwp',
      'fotowoltaika-powyzej-6-5-kw-ppoz-zawiadomienie-psp',
      'jak-dobrac-magazyn-energii-do-fotowoltaiki',
      'falownik-nie-laduje-magazynu-energii-diagnostyka',
      'falownik-1-fazowy-czy-3-fazowy',
    ],
  },
  {
    slug: 'fotowoltaika-powyzej-6-5-kw-ppoz-zawiadomienie-psp',
    title: 'Fotowoltaika powyżej 6,5 kW i straż pożarna: co naprawdę obowiązuje w 2026 i dlaczego większość poradników jest nieaktualna',
    seoTitle: 'Fotowoltaika powyżej 6,5 kW: straż pożarna 2026',
    seoDescription: 'Powyżej 6,5 kWp potrzebujesz uzgodnienia z rzeczoznawcą ppoż i zawiadomienia PSP z planem dla ratowników. Stan prawny 2026 i 5 błędów z innych poradników.',
    category: 'instalacje-pv',
    breadcrumbTopic: 'Formalności',
    lead: 'PV ponad 6,5 kWp: uzgodnienie z rzeczoznawcą ppoż i zawiadomienie PSP z planem dla ratowników. Stan prawny 2026, nieaktualne poradniki i realne kary.',
    updatedAt: '2026-10-09',
    readingTime: 8,
    featured: false,
    // Przypięty na stronie głównej (Home.jsx) przed PME2: przypięte idą w kolejności z tej listy.
    homePin: true,
    status: 'published',
    cover: 'offers',
    hero: { subtitle: 'Próg obowiązku ppoż · liczony po mocy modułów', value: '6,5', unit: 'kWp' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/instalacje-pv/fotowoltaika-powyzej-6-5-kw-ppoz-zawiadomienie-psp.md`,
    related: [
      'zgloszenie-mikroinstalacji-do-osd',
      'jak-porownac-oferty-na-instalacje-pv',
      'oferta-fotowoltaika-z-magazynem-co-sprawdzic',
      'ile-kosztuje-fotowoltaika-z-magazynem-energii',
    ],
    relatedProducts: {
      all: { label: 'Zgłoszenie mikroinstalacji do OSD', to: '/zgloszenie-mikroinstalacji' },
      items: [
        { label: 'Zawiadomienie do PSP i plan dla ekip ratowniczych', to: '/zawiadomienie-psp' },
      ],
    },
  },
  // ===== Formalności u operatora sieci (klaster SEO 8, 2026-10-14) =====
  {
    slug: 'magazyn-energii-2-2-mocy-instalacji-nowelizacja-oze',
    title: 'Od 1 grudnia większy magazyn energii bez wniosku o warunki przyłączenia. Sprawdź, czy to Ciebie dotyczy',
    seoTitle: 'Większy magazyn energii bez wniosku od 1 grudnia',
    seoDescription: 'Od 1.12.2026 magazyn o mocy do 2,2 × mocy paneli nie wlicza się do mikroinstalacji, jeśli do sieci oddajesz najwyżej moc paneli. Bez wniosku o warunki.',
    category: 'instalacje-pv',
    breadcrumbTopic: 'Formalności u operatora sieci',
    lead: 'Od 1 grudnia 2026 magazyn o mocy do 2,2-krotności mocy paneli nie wlicza się do mocy mikroinstalacji, jeśli do sieci oddajesz najwyżej moc paneli. Zasada obejmuje nowe zgłoszenia i te złożone wcześniej, których operator nie rozpatrzył przed 1 grudnia.',
    updatedAt: '2026-10-19',
    readingTime: 9,
    featured: false,
    status: 'published',
    cover: 'osd',
    hero: { subtitle: 'Tyle razy moc magazynu może przekroczyć moc paneli od 1 grudnia 2026 bez doliczania do mocy instalacji', value: '2,2', unit: '×' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/instalacje-pv/magazyn-energii-2-2-mocy-instalacji-nowelizacja-oze.md`,
    related: [
      'zgloszenie-magazynu-energii-do-osd',
      'dotacja-na-magazyn-energii-pme2',
      'jaki-magazyn-energii-do-falownika',
      'czy-magazyn-energii-sie-oplaca',
    ],
    relatedProducts: REL_STORAGE,
  },
  {
    slug: 'zgloszenie-mikroinstalacji-do-osd',
    title: 'Zgłoszenie mikroinstalacji do operatora sieci w 2026: Enea, Energa, Tauron, PGE i Stoen obok siebie',
    seoTitle: 'Zgłoszenie mikroinstalacji do OSD 2026: 5 operatorów',
    seoDescription: 'Zgłoszenie mikroinstalacji składasz u OSD po montażu, 30 dni przed przyłączeniem. Porównanie wymagań Enei, Energi, Tauronu, PGE i Stoenu.',
    category: 'instalacje-pv',
    breadcrumbTopic: 'Formalności u operatora sieci',
    lead: 'Zgłoszenie składasz u swojego operatora sieci po montażu, co najmniej 30 dni przed przyłączeniem. Każdy z pięciu operatorów ma inny druk, kanał i listę załączników.',
    updatedAt: '2026-10-14',
    readingTime: 11,
    featured: false,
    status: 'published',
    cover: 'osd',
    hero: { subtitle: 'Na przyłączenie od zgłoszenia (art. 7 ust. 8d7 Prawa energetycznego)', value: '30', unit: 'dni' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/instalacje-pv/zgloszenie-mikroinstalacji-do-osd.md`,
    related: [
      'magazyn-energii-2-2-mocy-instalacji-nowelizacja-oze',
      'zgloszenie-magazynu-energii-do-osd',
      'certyfikat-nc-rfg-falownik-wykaz-ptpiree',
      'fotowoltaika-powyzej-6-5-kw-ppoz-zawiadomienie-psp',
      'falownik-1-fazowy-czy-3-fazowy',
    ],
  },
  {
    slug: 'zgloszenie-magazynu-energii-do-osd',
    title: 'Zgłoszenie magazynu energii do OSD: kiedy wystarczy zgłoszenie, a kiedy moc magazynu liczy się do mocy przyłączeniowej',
    seoTitle: 'Zgłoszenie magazynu energii do OSD: moc i terminy',
    seoDescription: 'Magazyn zgłaszasz do OSD 30 dni przed przyłączeniem albo 5 dni po dołożeniu. Moc magazynu dolicza się, gdy falownik lub magazyn przekracza moc paneli.',
    category: 'instalacje-pv',
    breadcrumbTopic: 'Formalności u operatora sieci',
    lead: 'Magazyn przy fotowoltaice zgłaszasz do operatora sieci. Moc magazynu dolicza się do mocy instalacji, gdy jego moc albo moc oddawana do sieci przekracza moc modułów, a wtedy zgłoszenie może nie wystarczyć.',
    updatedAt: '2026-10-14',
    readingTime: 12,
    featured: false,
    status: 'published',
    cover: 'osd',
    hero: { subtitle: 'Do tej pojemności magazyn nie wymaga pozwolenia ani zgłoszenia budowlanego, ale zgłoszenia do OSD tak', value: '30', unit: 'kWh' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/instalacje-pv/zgloszenie-magazynu-energii-do-osd.md`,
    related: [
      'magazyn-energii-2-2-mocy-instalacji-nowelizacja-oze',
      'zgloszenie-mikroinstalacji-do-osd',
      'dotacja-na-magazyn-energii-pme2',
      'magazyn-energii-do-istniejacej-instalacji-fotowoltaicznej',
      'jaki-magazyn-energii-do-falownika',
    ],
    relatedProducts: REL_STORAGE,
  },
  {
    slug: 'certyfikat-nc-rfg-falownik-wykaz-ptpiree',
    title: 'Certyfikat NC RfG falownika: wykaz PTPiREE 1.2 i 1.3, zmiana od 2027 i które falowniki w sklepach ją spełniają',
    seoTitle: 'Certyfikat NC RfG falownika: wykaz PTPiREE 1.3',
    seoDescription: 'Od zgłoszeń z 1.01.2027 operatorzy przyjmą tylko falowniki z wykazu PTPiREE 1.3. Sprawdź, które marki w nim są i co zrobić, gdy falownika brak.',
    category: 'instalacje-pv',
    breadcrumbTopic: 'Formalności u operatora sieci',
    lead: 'Od zgłoszeń mikroinstalacji składanych 1 stycznia 2027 operatorzy akceptują tylko falowniki z wykazu PTPiREE 1.3. W naszym katalogu taki certyfikat, ważny po 2026 roku, ma 16,4% ofert falowników.',
    updatedAt: '2026-10-14',
    readingTime: 11,
    featured: false,
    status: 'published',
    cover: 'osd',
    hero: { subtitle: 'Oferty falowników z certyfikatem z wykazu 1.3 ważnym po 2026', value: '16,4', unit: '% ofert' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/instalacje-pv/certyfikat-nc-rfg-falownik-wykaz-ptpiree.md`,
    related: [
      'zgloszenie-mikroinstalacji-do-osd',
      'falownik-1-fazowy-czy-3-fazowy',
      'jak-porownac-oferty-na-instalacje-pv',
      'oferta-fotowoltaika-z-magazynem-co-sprawdzic',
      'hoymiles-hit-czy-deye-sg05lp3',
    ],
  },
  {
    slug: 'czy-fotowoltaika-sie-oplaca',
    title: 'Czy fotowoltaika się opłaca w 2026? Zwrot w net-billingu policzony na cenach ze sklepów',
    seoTitle: 'Czy fotowoltaika się opłaca 2026? Zwrot 5 do 7 lat',
    seoDescription: 'Fotowoltaika bez magazynu zwraca się w 2026 po ok. 5 do 7 lat. Tabela 5, 8 i 10 kWp na cenach ze sklepów (13.10.2026) i cenach nadwyżek z PSE.',
    category: 'instalacje-pv',
    breadcrumbTopic: 'Opłacalność',
    lead: 'Rachunek zwrotu instalacji 5, 8 i 10 kWp bez magazynu przy autokonsumpcji 20 do 40%, na cenach ze sklepów i cenach nadwyżek z PSE z 12 miesięcy. 8 kWp za ok. 25 300 zł zwraca się po ok. 5,7 roku.',
    updatedAt: '2026-10-14',
    readingTime: 14,
    featured: false,
    status: 'published',
    cover: 'offers',
    hero: { subtitle: 'Zwrot PV bez magazynu, net-billing, ceny z 13.10.2026', value: '4,9 do 7,0', unit: 'lat' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/instalacje-pv/czy-fotowoltaika-sie-oplaca.md`,
    related: [
      'czy-magazyn-energii-sie-oplaca',
      'cena-fotowoltaiki-za-kwp',
      'taryfa-dynamiczna-czy-sie-oplaca',
      'ile-kosztuje-fotowoltaika-z-magazynem-energii',
      'jak-porownac-oferty-na-instalacje-pv',
    ],
  },
  {
    slug: 'cena-fotowoltaiki-za-kwp',
    title: 'Cena fotowoltaiki za kWp w 2026 (3 do 15 kWp)',
    seoTitle: 'Cena fotowoltaiki za kWp 2026: 3 do 15 kWp',
    seoDescription: 'Cena fotowoltaiki za kWp w 2026: 10 kWp bez magazynu ok. 26 400 do 34 200 zł, czyli ok. 3 030 zł/kWp. Tabela 3 do 15 kWp, stan cen 13.10.2026.',
    category: 'instalacje-pv',
    breadcrumbTopic: 'Ceny instalacji',
    lead: 'Instalacja fotowoltaiczna 10 kWp bez magazynu kosztuje typowo ok. 26 400 do 34 200 zł brutto, czyli ok. 2 640 do 3 420 zł za kWp, z montażem i VAT 8% (ceny z 13.10.2026). Przy 3 kWp to ok. 4 080 zł/kWp, przy 15 kWp ok. 2 930 zł/kWp.',
    updatedAt: '2026-10-14',
    readingTime: 11,
    featured: false,
    status: 'published',
    cover: 'offers',
    hero: { subtitle: 'Typowa cena instalacji 10 kWp bez magazynu, brutto z montażem, 13.10.2026', value: 'ok. 3 030', unit: 'zł/kWp' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/instalacje-pv/cena-fotowoltaiki-za-kwp.md`,
    related: [
      'fotowoltaika-2027-ile-zaplacisz-ceny-z-ofert',
      'czy-fotowoltaika-sie-oplaca',
      'ile-kosztuje-fotowoltaika-z-magazynem-energii',
      'jak-porownac-oferty-na-instalacje-pv',
      'ile-paneli-na-falownik-przewymiarowanie',
      'oferta-fotowoltaika-z-magazynem-co-sprawdzic',
    ],
  },
  {
    slug: 'ile-kosztuje-fotowoltaika-z-magazynem-energii',
    title: 'Ile kosztuje fotowoltaika z magazynem energii w 2026? Ceny dla 5, 8 i 10 kWp',
    seoTitle: 'Ile kosztuje fotowoltaika z magazynem w 2026?',
    seoDescription: 'Instalacja 10 kWp z magazynem 10 kWh kosztuje typowo 36,5 do 45,6 tys. zł brutto, bez magazynu 26,4 do 34,2 tys. zł. Ceny dla 5, 8 i 10 kWp ze sklepów.',
    category: 'instalacje-pv',
    breadcrumbTopic: 'Ceny instalacji',
    lead: 'Typowe ceny fotowoltaiki 5, 8 i 10 kWp z magazynem energii i bez, z cen sprzętu w sklepach z 13.10.2026, metodą sprawdzoną na realnych ofertach instalatorów, oraz porównanie z innymi źródłami.',
    updatedAt: '2026-10-14',
    readingTime: 10,
    featured: false,
    status: 'published',
    cover: 'offers',
    hero: { subtitle: 'Instalacja 10 kWp z magazynem 10 kWh · ceny z 13.10.2026', value: '36,5–45,6', unit: 'tys. zł' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/instalacje-pv/ile-kosztuje-fotowoltaika-z-magazynem-energii.md`,
    related: [
      'fotowoltaika-2027-ile-zaplacisz-ceny-z-ofert',
      'cena-fotowoltaiki-za-kwp',
      'oferta-fotowoltaika-z-magazynem-co-sprawdzic',
      'ile-kosztuje-magazyn-energii',
      'dotacja-na-magazyn-energii-pme2',
    ],
    relatedProducts: REL_STORAGE,
  },
  {
    slug: 'fotowoltaika-2027-ile-zaplacisz-ceny-z-ofert',
    title: 'Planujesz fotowoltaikę w 2027 roku? Ile naprawdę zapłacisz według prawdziwych ofert',
    seoTitle: 'Fotowoltaika 2027: ile zapłacisz? Ceny z ofert',
    seoDescription: 'Ceny fotowoltaiki z prawdziwych ofert instalatorów: 10 kWp z magazynem mediana 45 000 zł, 5 kWp z magazynem 33 000 zł. Wykres, tabele i PME2 w 2027.',
    category: 'instalacje-pv',
    breadcrumbTopic: 'Ceny instalacji',
    lead: 'Ile kosztuje fotowoltaika z magazynem i bez według prawdziwych ofert instalatorów z jesieni 2026: 10 kWp z magazynem typowo 39 500 do 49 900 zł, a 5 kWp niewiele mniej.',
    updatedAt: '2026-10-29',
    readingTime: 9,
    featured: false,
    status: 'published',
    cover: 'offers',
    hero: { subtitle: 'Środkowa oferta na ok. 10 kWp z magazynem, brutto z montażem, jesień 2026', value: '45', unit: 'tys. zł' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/instalacje-pv/fotowoltaika-2027-ile-zaplacisz-ceny-z-ofert.md`,
    related: [
      'ile-kosztuje-fotowoltaika-z-magazynem-energii',
      'cena-fotowoltaiki-za-kwp',
      'dotacja-na-magazyn-energii-pme2',
      'oferta-fotowoltaika-z-magazynem-co-sprawdzic',
      'jak-porownac-oferty-na-instalacje-pv',
    ],
    relatedProducts: REL_STORAGE,
  },
  {
    slug: 'oferta-fotowoltaika-z-magazynem-co-sprawdzic',
    title: 'Oferta na fotowoltaikę z magazynem energii: 7 rzeczy do sprawdzenia przed podpisaniem',
    seoTitle: 'Oferta PV z magazynem: 7 rzeczy do sprawdzenia',
    seoDescription: 'Cena wobec sprzętu, pojemność użytkowa, zgodność falownika z magazynem, zasilanie awaryjne, PME2 i serwis. Co powinna zawierać oferta i typowe ceny.',
    category: 'instalacje-pv',
    breadcrumbTopic: 'Zakup instalacji',
    lead: 'Co powinna zawierać oferta PV z magazynem i co w niej sprawdzić: cena wobec sprzętu, pojemność i gwarancja magazynu, zgodność z falownikiem, zasilanie awaryjne, dotacja PME2 i serwis.',
    updatedAt: '2026-10-14',
    readingTime: 9,
    featured: false,
    status: 'published',
    cover: 'offers',
    hero: { subtitle: 'Oferta PV z magazynem · lista kontrolna przed podpisaniem umowy', value: '7', unit: 'punktów' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/instalacje-pv/oferta-fotowoltaika-z-magazynem-co-sprawdzic.md`,
    related: [
      'gwarancja-rekojmia-fotowoltaika-magazyn',
      'ile-kosztuje-fotowoltaika-z-magazynem-energii',
      'jak-porownac-oferty-na-instalacje-pv',
      'zasilanie-awaryjne-fotowoltaika-caly-dom-czy-wybrane-obwody',
    ],
    relatedProducts: REL_STORAGE,
  },
  {
    slug: 'zasilanie-awaryjne-fotowoltaika-caly-dom-czy-wybrane-obwody',
    title: 'Zasilanie awaryjne z fotowoltaiki: cały dom czy wybrane obwody i co naprawdę pociągnie backup',
    seoTitle: 'Zasilanie awaryjne PV: cały dom, obwody, moc backupu',
    seoDescription: 'Większość hybryd zasila przy braku prądu wybrane obwody. Czas przełączenia 17 serii, limit baterii i fazy, pompa ciepła, koszty i agregat. Fakty i mity.',
    category: 'falowniki',
    breadcrumbTopic: 'Zasilanie awaryjne',
    lead: 'Większość hybryd zasila przy braku prądu tylko wybrane obwody. Deklarowane czasy przełączenia 17 serii, limity baterii i fazy, pompa ciepła, koszty, agregat i fakty o „0 ms”.',
    updatedAt: '2026-11-02',
    readingTime: 10,
    featured: false,
    status: 'published',
    cover: 'storage',
    hero: { subtitle: 'Zasilanie awaryjne · 17 serii falowników według dokumentacji producentów', value: '17', unit: 'serii' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/falowniki/zasilanie-awaryjne-fotowoltaika-caly-dom-czy-wybrane-obwody.md`,
    related: [
      'oferta-fotowoltaika-z-magazynem-co-sprawdzic',
      'pobor-wlasny-falownika-hybrydowego',
      'magazyn-energii-lv-czy-hv',
      'hoymiles-hit-czy-deye-sg05lp3',
      'dotacja-na-magazyn-energii-pme2',
    ],
    relatedProducts: REL_PRODUCTS,
  },
  {
    slug: 'ile-kosztuje-magazyn-energii',
    title: 'Ile kosztuje magazyn energii w 2026? Ceny 5, 10, 15 i 20 kWh',
    seoTitle: 'Ile kosztuje magazyn energii w 2026? Ceny za kWh',
    seoDescription: 'Magazyn 10 kWh kosztuje typowo 7 500 do 13 000 zł, 20 kWh 14 900 do 25 900 zł. Cena za kWh: typowo 746 do 1 297 zł, ceny z 488 modeli z 13.10.2026.',
    category: 'magazyny',
    breadcrumbTopic: 'Ceny magazynów',
    lead: 'Ceny magazynów energii 5, 10, 15, 20 i 30 kWh z 488 modeli w sklepach (13.10.2026), cena za kWh według półki, marki i napięcia, cena z montażem i przykład dotacji PME2.',
    updatedAt: '2026-10-14',
    readingTime: 11,
    featured: false,
    status: 'published',
    cover: 'storage',
    hero: { subtitle: 'Magazyn 10 kWh · typowa cena za kWh razy pojemność, 13.10.2026', value: '9 800', unit: 'zł' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/magazyny/ile-kosztuje-magazyn-energii.md`,
    related: [
      'czy-magazyn-energii-sie-oplaca',
      'ile-kosztuje-fotowoltaika-z-magazynem-energii',
      'jak-dobrac-magazyn-energii-do-fotowoltaiki',
      'dotacja-na-magazyn-energii-pme2',
    ],
    relatedProducts: REL_STORAGE,
  },
  {
    slug: 'pobor-wlasny-falownika-hybrydowego',
    title: 'Pobór własny falownika hybrydowego: ile bierze Deye i czy to się opłaca',
    seoTitle: 'Pobór własny falownika hybrydowego: Deye i inni',
    seoDescription: 'Deye i inne hybrydy biorą od kilkunastu do ponad 100 W, zależnie od trybu. Fakty i mity, pomiary, koszt w złotych i wpływ na magazyn 5 i 10 kWh.',
    category: 'falowniki',
    breadcrumbTopic: 'Dobór falownika',
    lead: 'Deye z aktywną baterią bierze około 70 do 120 W. Fakty i mity, koszt w złotych, dlaczego jedni mówią 15 W, a inni 100 W i co to znaczy dla magazynu 5 i 10 kWh.',
    updatedAt: '2026-11-02',
    readingTime: 9,
    featured: false,
    status: 'published',
    cover: 'diagnostics',
    hero: { subtitle: 'Pobór 100 W przez cały rok', value: '876', unit: 'kWh' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/falowniki/pobor-wlasny-falownika-hybrydowego.md`,
    related: [
      'czy-magazyn-energii-sie-oplaca',
      'jak-dobrac-magazyn-energii-do-fotowoltaiki',
      'ems-dotacja-pme2-wymagania',
      'falownik-wylacza-sie-253-v',
    ],
  },
  {
    slug: 'falownik-wylacza-sie-253-v',
    title: 'Falownik wyłącza się przy 253 V: co sprawdzić, zanim zapłacisz za pomiar',
    seoTitle: 'Falownik wyłącza się przy 253 V: co sprawdzić',
    seoDescription: '253 V to średnia z 10 minut, a P(U) ogranicza moc już od 248,4 V. Co sprawdzić, kiedy reklamacja ma sens i czy pomoże magazyn. Fakty i mity.',
    category: 'falowniki',
    breadcrumbTopic: 'Dobór falownika',
    lead: 'Liczy się średnia z 10 minut, a moc może spadać już od 248,4 V bez błędu. Fakty i mity, co sprawdzić po kolei, kiedy reklamacja ma sens, czy pomoże magazyn.',
    updatedAt: '2026-11-02',
    readingTime: 9,
    featured: false,
    status: 'published',
    cover: 'diagnostics',
    hero: { subtitle: 'Tyle mocy zostaje przy 253 V', value: '20', unit: '%' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/falowniki/falownik-wylacza-sie-253-v.md`,
    related: [
      'pobor-wlasny-falownika-hybrydowego',
      'czy-magazyn-energii-sie-oplaca',
      'falownik-1-fazowy-czy-3-fazowy',
    ],
  },
  {
    slug: 'hoymiles-hit-czy-deye-sg05lp3',
    title: 'Hoymiles HIT czy Deye SG05LP3: który falownik wybrać do domu',
    seoTitle: 'Hoymiles HIT czy Deye SG05LP3: który wybrać',
    seoDescription: 'Ceny do 15 kW prawie równe. HIT ma od 8 kW więcej MPPT, Deye ekran i większy prąd na MPPT. Certyfikat na 2027, sprawność, gwarancja. Fakty i mity.',
    category: 'falowniki',
    breadcrumbTopic: 'Dobór falownika',
    lead: 'Do 15 kW kosztują prawie tyle samo, więc decyduje dach. Fakty i mity, MPPT, ceny, gwarancja i to, co sprawdzić w certyfikacie przed zgłoszeniem w 2027 roku.',
    updatedAt: '2026-11-02',
    readingTime: 10,
    featured: false,
    status: 'published',
    cover: 'diagnostics',
    hero: { subtitle: 'Różnica sprawności rocznie, do około', value: '100', unit: 'zł' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/falowniki/hoymiles-hit-czy-deye-sg05lp3.md`,
    related: [
      'pobor-wlasny-falownika-hybrydowego',
      'certyfikat-nc-rfg-falownik-wykaz-ptpiree',
      'magazyn-energii-lv-czy-hv',
      'jaki-magazyn-energii-do-falownika',
    ],
  },
  {
    slug: 'ems-dotacja-pme2-wymagania',
    title: 'EMS w dotacji PME2: czy musi być osobny i co z Deye, Sigenergy, Hoymiles',
    seoTitle: 'EMS w dotacji PME2: wymagania i marki',
    seoDescription: 'EMS w PME2 nie musi być osobnym urządzeniem. Co mówią dokumenty NFOŚiGW, jakie oświadczenia się składa i które marki mają dokumenty cyberbezpieczeństwa.',
    category: 'magazyny',
    breadcrumbTopic: 'Dofinansowanie',
    lead: 'EMS w PME2 może być funkcją falownika, modułem magazynu albo systemem zewnętrznym. Co jest dowodem spełnienia wymogów i które marki mają publiczne dokumenty.',
    updatedAt: '2026-11-02',
    readingTime: 7,
    featured: false,
    status: 'published',
    cover: 'subsidy',
    hero: { subtitle: 'Dopuszczone formy EMS w programie PME2', value: '3', unit: 'formy' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/magazyny/ems-dotacja-pme2-wymagania.md`,
    related: [
      'dotacja-na-magazyn-energii-pme2',
      'wniosek-pme2-krok-po-kroku',
      'formularz-wniosku-pme2-gwd-pole-po-polu',
      'pobor-wlasny-falownika-hybrydowego',
    ],
  },
  {
    slug: 'dotacja-na-magazyn-energii-pme2',
    title: 'Dotacja na magazyn energii 2026: do 16 000 zł z programu PME2',
    seoTitle: 'Dotacja na magazyn energii 2026: do 16 000 zł',
    seoDescription: 'PME2 daje do 16 000 zł na magazyn energii, nabór od 20.10.2026. Jaki magazyn przejdzie (10 kWh, zasada 2:1, 3 000 zł/kWh) i dlaczego nie czekać.',
    category: 'magazyny',
    breadcrumbTopic: 'Dofinansowanie',
    lead: 'Do 16 000 zł na magazyn energii z programu PME2: nabór od 20 października 2026, jaki magazyn przejdzie (10 kWh, zasada 2:1, 3 000 zł/kWh), co z programem Mój Prąd i jak połączyć dotację z ulgą termomodernizacyjną.',
    updatedAt: '2026-11-02',
    readingTime: 18,
    featured: false,
    // Przypięty jako pierwszy w kaflu Bazy wiedzy na stronie głównej (Home.jsx).
    homePin: true,
    status: 'published',
    cover: 'subsidy',
    hero: { subtitle: 'Program PME2 · 30% kosztów, maks. 800 zł za kWh', value: '16 000', unit: 'zł' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/magazyny/dotacja-na-magazyn-energii-pme2.md`,
    related: [
      'ems-dotacja-pme2-wymagania',
      'pme2-zmiany-po-starcie-naboru',
      'formularz-wniosku-pme2-gwd-pole-po-polu',
      'wniosek-pme2-krok-po-kroku',
      'jak-dobrac-magazyn-energii-do-fotowoltaiki',
      'falownik-nie-laduje-magazynu-energii-diagnostyka',
      'jak-porownac-oferty-na-instalacje-pv',
    ],
    relatedProducts: REL_STORAGE,
  },
  {
    slug: 'wniosek-pme2-krok-po-kroku',
    title: 'Wniosek PME2 krok po kroku: dokumenty, protokół odbioru i generator GWD',
    seoTitle: 'Wniosek PME2 krok po kroku: dokumenty i protokół',
    seoDescription: 'Wniosek PME2 złożysz tylko w GWD od 20.10.2026, a brak jednego załącznika to odrzucenie bez poprawki. Dokumenty, protokół odbioru i 10 powodów odrzucenia.',
    category: 'magazyny',
    breadcrumbTopic: 'Dofinansowanie',
    lead: 'Jak złożyć wniosek PME2 od 20 października 2026: dokumenty i kto je wystawia, protokół odbioru pole po polu, pułapki w generatorze GWD i powody odrzucenia.',
    updatedAt: '2026-10-22',
    readingTime: 11,
    featured: false,
    status: 'published',
    cover: 'subsidy',
    hero: { subtitle: 'Na poprawkę wniosku PME2 · najwyżej dwa wezwania', value: '10', unit: 'dni' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/magazyny/wniosek-pme2-krok-po-kroku.md`,
    related: [
      'pme2-zmiany-po-starcie-naboru',
      'formularz-wniosku-pme2-gwd-pole-po-polu',
      'dotacja-na-magazyn-energii-pme2',
      'oferta-fotowoltaika-z-magazynem-co-sprawdzic',
      'jak-dobrac-magazyn-energii-do-fotowoltaiki',
    ],
    relatedProducts: {
      all: { label: 'Sprawdź, czy oferta spełnia warunki PME2', to: '/sprawdz-oferte' },
      items: [
        { label: 'Zgłoszenie mikroinstalacji z magazynem do OSD', to: '/zgloszenie-mikroinstalacji' },
        { label: 'Teczka PME2: protokół odbioru i lista załączników', to: '/teczka-pme2' },
      ],
    },
  },
  {
    slug: 'formularz-wniosku-pme2-gwd-pole-po-polu',
    title: 'Wniosek PME2 w generatorze GWD: co wpisać w każde pole (ze zrzutami)',
    seoTitle: 'Wniosek PME2 w GWD: co wpisać w każde pole',
    seoDescription: 'Formularz PME2 w generatorze GWD pole po polu, ze zrzutami: dwa pola PPE, moc bez magazynu, koszty brutto, model z karty, EMS i załączniki.',
    category: 'magazyny',
    breadcrumbTopic: 'Dofinansowanie',
    lead: 'Jak wypełnić wniosek PME2 w generatorze GWD: dane wnioskodawcy, numer PPE, moc, koszty brutto, falownik, EMS i załączniki, na zrzutach z pokazu NFOŚiGW.',
    updatedAt: '2026-10-22',
    readingTime: 15,
    featured: false,
    status: 'published',
    cover: 'subsidy',
    hero: { subtitle: 'Limit kosztów magazynu we wniosku PME2 · kwoty brutto', value: '3 000', unit: 'zł/kWh' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/magazyny/formularz-wniosku-pme2-gwd-pole-po-polu.md`,
    related: [
      'pme2-zmiany-po-starcie-naboru',
      'wniosek-pme2-krok-po-kroku',
      'dotacja-na-magazyn-energii-pme2',
      'zgloszenie-magazynu-energii-do-osd',
      'jak-dobrac-magazyn-energii-do-fotowoltaiki',
    ],
    relatedProducts: {
      all: { label: 'Sprawdź, czy oferta spełnia warunki PME2', to: '/sprawdz-oferte' },
      items: [
        { label: 'Teczka PME2: protokół odbioru i lista załączników', to: '/teczka-pme2' },
        { label: 'Zgłoszenie mikroinstalacji z magazynem do OSD', to: '/zgloszenie-mikroinstalacji' },
      ],
    },
  },
  {
    slug: 'pme2-zmiany-po-starcie-naboru',
    title: 'PME2 po starcie naboru: nowy protokół odbioru, instrukcja GWD i to, co warto wiedzieć przed wysłaniem wniosku',
    seoTitle: 'PME2 po starcie naboru: co się zmieniło',
    seoDescription: 'Nowy wzór protokołu odbioru z 22.10.2026, instrukcja GWD części 2, faktury w ZIP i termin oceny wniosków. Tylko zmiany od startu naboru PME2.',
    category: 'magazyny',
    breadcrumbTopic: 'Dofinansowanie',
    lead: 'Co zmieniło się w PME2 od startu naboru 20.10.2026: nowy wzór protokołu odbioru, instrukcja GWD, konta dla firm i termin oceny. Kwoty bez zmian.',
    updatedAt: '2026-10-22',
    readingTime: 7,
    featured: false,
    status: 'published',
    cover: 'subsidy',
    hero: { subtitle: 'Tylu wniosków PME2 spodziewa się NFOŚiGW', value: '60–70', unit: 'tys.' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/magazyny/pme2-zmiany-po-starcie-naboru.md`,
    related: [
      'formularz-wniosku-pme2-gwd-pole-po-polu',
      'wniosek-pme2-krok-po-kroku',
      'dotacja-na-magazyn-energii-pme2',
    ],
    relatedProducts: {
      all: { label: 'Sprawdź, czy oferta spełnia warunki PME2', to: '/sprawdz-oferte' },
      items: [
        { label: 'Teczka PME2: protokół odbioru na wzorze z 22.10.2026', to: '/teczka-pme2' },
        { label: 'Zgłoszenie mikroinstalacji z magazynem do OSD', to: '/zgloszenie-mikroinstalacji' },
      ],
    },
  },
  // ===== Zgodność falownika z magazynem (klaster SEO 6, 2026-10-14) =====
  {
    slug: 'czy-magazyn-energii-sie-oplaca',
    title: 'Czy magazyn energii się opłaca? Rachunek dla nowej i istniejącej instalacji, z PME2 i bez',
    seoTitle: 'Czy magazyn energii się opłaca? Rachunek 2026',
    seoDescription: 'Magazyn 10 kWh przy PV 5 kWp: ok. 710 zł rocznie, zwrot po 15 latach bez dotacji, 10,5 z PME2. Rachunek na cenach RCE, nowa i istniejąca instalacja.',
    category: 'magazyny',
    breadcrumbTopic: 'Opłacalność',
    lead: 'Magazyn energii w net-billingu się opłaca, ale zwykle dopiero z dotacją. Typowy magazyn 10 kWh przy PV 5 kWp oszczędza ok. 710 zł rocznie i zwraca się po ok. 15 latach bez dotacji albo po ok. 10,5 roku z PME2.',
    updatedAt: '2026-10-14',
    readingTime: 16,
    featured: false,
    status: 'published',
    cover: 'battery-price',
    hero: { subtitle: 'Zwrot magazynu 10 kWh z dotacją PME2', value: '10,6', unit: 'roku' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/magazyny/czy-magazyn-energii-sie-oplaca.md`,
    related: [
      'dotacja-na-magazyn-energii-pme2',
      'czy-fotowoltaika-sie-oplaca',
      'ile-kosztuje-magazyn-energii',
      'magazyn-energii-do-istniejacej-instalacji-fotowoltaicznej',
    ],
    relatedProducts: REL_STORAGE,
  },
  {
    slug: 'jaki-magazyn-energii-do-falownika',
    title: 'Jaki magazyn energii do falownika? Tabela zgodności dla 15 marek',
    seoTitle: 'Jaki magazyn energii do falownika? 15 marek',
    seoDescription: 'O magazynie decyduje falownik: napięcie LV albo HV, protokół CAN lub RS485 i lista producenta. Zgodne baterie dla Deye, Huawei, GoodWe i 12 innych marek.',
    category: 'magazyny',
    breadcrumbTopic: 'Zgodność falownika z magazynem',
    lead: 'Magazyn dobiera się do falownika, a nie odwrotnie. Trzy warunki zgodności, odpowiedzi dla Deye, Huawei, GoodWe, Growatt, Sofar, Solis i Froniusa oraz pełna tabela 15 marek na dole artykułu.',
    updatedAt: '2026-10-14',
    readingTime: 14,
    featured: false,
    status: 'published',
    cover: 'compat',
    hero: { subtitle: 'Marek falowników w tabeli zgodności, ze źródłami producentów', value: '15', unit: 'marek falowników' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/magazyny/jaki-magazyn-energii-do-falownika.md`,
    related: [
      'magazyn-energii-do-istniejacej-instalacji-fotowoltaicznej',
      'jak-dobrac-magazyn-energii-do-fotowoltaiki',
      'falownik-nie-laduje-magazynu-energii-diagnostyka',
      'oferta-fotowoltaika-z-magazynem-co-sprawdzic',
      'dotacja-na-magazyn-energii-pme2',
    ],
    relatedProducts: REL_STORAGE,
  },
  {
    slug: 'magazyn-energii-do-istniejacej-instalacji-fotowoltaicznej',
    title: 'Magazyn energii do istniejącej instalacji: co dołożyć do falownika sieciowego i hybrydowego',
    seoTitle: 'Magazyn energii do istniejącej instalacji PV',
    seoDescription: 'Do hybrydy dołożysz baterię z listy producenta, do falownika sieciowego magazyn AC albo hybrydę. Straty AC wobec DC: ok. 30 do 195 zł rocznie.',
    category: 'magazyny',
    breadcrumbTopic: 'Zgodność falownika z magazynem',
    lead: 'To, jaki magazyn dołożysz do działającej fotowoltaiki, zależy od falownika: do hybrydowego bateria z listy producenta, do sieciowego magazyn AC albo wymiana na hybrydę. Porównujemy koszt urządzeń, straty energii w złotych, zasilanie awaryjne i PME2.',
    updatedAt: '2026-10-14',
    readingTime: 12,
    featured: false,
    status: 'published',
    cover: 'retrofit',
    hero: { subtitle: 'Tyle więcej rocznie mogą kosztować straty magazynu AC 48 V niż DC wysokonapięciowego', value: 'do 195', unit: 'zł' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/magazyny/magazyn-energii-do-istniejacej-instalacji-fotowoltaicznej.md`,
    related: [
      'jaki-magazyn-energii-do-falownika',
      'jak-dobrac-magazyn-energii-do-fotowoltaiki',
      'dotacja-na-magazyn-energii-pme2',
      'zasilanie-awaryjne-fotowoltaika-caly-dom-czy-wybrane-obwody',
    ],
    relatedProducts: REL_STORAGE,
  },
  {
    slug: 'falownik-nie-laduje-magazynu-energii-diagnostyka',
    title: 'Falownik nie ładuje magazynu energii z paneli: diagnostyka krok po kroku',
    seoTitle: 'Falownik nie ładuje magazynu energii: diagnostyka',
    seoDescription: 'Magazyn nie ładuje się mimo słońca? Zwykle winne są ustawienia trybu pracy, pełna bateria albo komunikacja falownik-BMS. Tabela 7 objawów i co sprawdzić.',
    category: 'magazyny',
    breadcrumbTopic: 'Diagnostyka i serwis',
    lead: 'Magazyn energii nie ładuje się mimo słońca? Diagnostyka krok po kroku: ustawienia trybu pracy, komunikacja falownik-BMS, firmware i kompatybilność.',
    updatedAt: '2026-07-26',
    readingTime: 8,
    featured: false,
    status: 'published',
    cover: 'diagnostics',
    hero: { subtitle: 'Magazyn nie ładuje się z paneli · diagnostyka w 7 krokach', value: '7', unit: 'kroków' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/magazyny/falownik-nie-laduje-magazynu-energii-diagnostyka.md`,
    related: [
      'jaki-magazyn-energii-do-falownika',
      'jak-dobrac-magazyn-energii-do-fotowoltaiki',
      'jak-porownac-oferty-na-instalacje-pv',
    ],
  },
  {
    slug: 'rozbudowa-magazynu-energii',
    title: 'Rozbudowa magazynu energii: co sprawdzić przed zakupem pierwszego modułu',
    seoTitle: 'Rozbudowa magazynu energii: terminy i gwarancja',
    seoDescription: 'Kiedy i jak dołożyć moduł do magazynu? Zasady Deye, Dyness, BYD, Huawei i FoxESS, gwarancja, 5 dni na zgłoszenie, 30 kWh i dotacja PME2. Fakty i mity.',
    category: 'magazyny',
    breadcrumbTopic: 'Dobór magazynu',
    lead: 'Terminy na dołożenie modułu różnią się od 6 miesięcy do braku limitu. Fakty i mity, zasady producentów, gwarancja, formalności, dotacja i pięć pytań przed zakupem.',
    updatedAt: '2026-11-02',
    readingTime: 8,
    featured: false,
    status: 'published',
    cover: 'storage',
    hero: { subtitle: 'Termin na dołożenie modułu w Dyness Tower', value: '6', unit: 'mies.' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/magazyny/rozbudowa-magazynu-energii.md`,
    related: [
      'gwarancja-rekojmia-fotowoltaika-magazyn',
      'magazyn-energii-lv-czy-hv',
      'jaki-magazyn-energii-do-falownika',
      'zgloszenie-magazynu-energii-do-osd',
      'dotacja-na-magazyn-energii-pme2',
    ],
  },
  {
    slug: 'magazyn-energii-lv-czy-hv',
    title: 'Magazyn energii LV czy HV: fakty i mity o niskim i wysokim napięciu',
    seoTitle: 'Magazyn energii LV czy HV? Fakty, mity, ceny',
    seoDescription: 'LV czy HV? HV ma około 4 punkty sprawności więcej na cyklu, ale to 15 do 120 zł rocznie przy dopłacie od 0,9 tys. zł. Ceny, bezpieczeństwo, rozbudowa.',
    category: 'magazyny',
    breadcrumbTopic: 'Dobór magazynu',
    lead: 'HV ma lepszą sprawność, ale rzadko zwraca dopłatę. Fakty i mity, ceny z katalogu, koszt różnicy sprawności w złotych, bezpieczeństwo i zasady rozbudowy.',
    updatedAt: '2026-11-02',
    readingTime: 9,
    featured: false,
    status: 'published',
    cover: 'storage',
    hero: { subtitle: 'Przewaga HV w sprawności na pełnym cyklu, według kart', value: '4', unit: 'pkt proc.' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/magazyny/magazyn-energii-lv-czy-hv.md`,
    related: [
      'jak-dobrac-magazyn-energii-do-fotowoltaiki',
      'jaki-magazyn-energii-do-falownika',
      'pobor-wlasny-falownika-hybrydowego',
      'ile-kosztuje-magazyn-energii',
      'rozbudowa-magazynu-energii',
    ],
  },
  {
    slug: 'jak-dobrac-magazyn-energii-do-fotowoltaiki',
    title: 'Jak dobrać magazyn energii do instalacji fotowoltaicznej? Pojemność, falownik i najczęstsze błędy',
    seoTitle: 'Dobór magazynu energii do PV: zwykle 7 do 12 kWh',
    seoDescription: 'Dla domu z PV 5 do 10 kWp to zwykle 7 do 12 kWh. Jak liczyć pojemność z profilu zużycia, LV czy HV, zgodność z falownikiem i najczęstsze błędy doboru.',
    category: 'magazyny',
    breadcrumbTopic: 'Dobór magazynu',
    lead: 'Jak dobrać pojemność i moc magazynu energii do instalacji PV: profil zużycia, LV vs HV, kompatybilność z falownikiem i najczęstsze błędy doboru.',
    updatedAt: '2026-11-02',
    readingTime: 11,
    featured: false,
    status: 'published',
    cover: 'storage',
    hero: { subtitle: 'Dobór magazynu energii · 7-12 kWh dla typowego domu', value: '7-12', unit: 'kWh' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/magazyny/jak-dobrac-magazyn-energii-do-fotowoltaiki.md`,
    related: [
      'czy-magazyn-energii-sie-oplaca',
      'jaki-magazyn-energii-do-falownika',
      'dotacja-na-magazyn-energii-pme2',
      'falownik-1-fazowy-czy-3-fazowy',
      'falownik-nie-laduje-magazynu-energii-diagnostyka',
      'jak-porownac-oferty-na-instalacje-pv',
    ],
  },

  // ===== Dla firm PV (klaster SEO 7, 2026-10-14) =====
  {
    slug: 'program-do-wyceny-fotowoltaiki',
    title: 'Program do wyceny fotowoltaiki i CRM dla instalatora: porównanie 2026',
    seoTitle: 'Program do wyceny fotowoltaiki i CRM: 2026',
    seoDescription: '12 programów do wyceny PV i CRM dla instalatora: funkcje, ceny netto i darmowe plany z odczytem 14.10.2026. Czym różni się VoltValue i co wybrać.',
    category: 'instalacje-pv',
    breadcrumbTopic: 'Dla firm PV',
    lead: 'Porównaliśmy 12 programów do wyceny fotowoltaiki i CRM dla instalatora: trzy mają darmowy plan, abonamenty kosztują od 15 do 377 zł netto za użytkownika miesięcznie. VoltValue (nasz produkt) liczy wycenę z cen ok. 30 sklepów i ma w jednym miejscu dokumenty OSD, PSP i PME2.',
    updatedAt: '2026-10-14',
    readingTime: 11,
    featured: false,
    status: 'published',
    cover: 'offers',
    hero: { subtitle: 'Programów porównanych 14.10.2026', value: '12', unit: 'narzędzi' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/instalacje-pv/program-do-wyceny-fotowoltaiki.md`,
    related: [
      'jak-przygotowac-oferte-na-fotowoltaike',
      'jak-porownac-oferty-na-instalacje-pv',
      'cena-fotowoltaiki-za-kwp',
      'zgloszenie-mikroinstalacji-do-osd',
      'certyfikat-nc-rfg-falownik-wykaz-ptpiree',
    ],
  },
  {
    slug: 'jak-przygotowac-oferte-na-fotowoltaike',
    title: 'Jak przygotować ofertę na fotowoltaikę dla klienta: wzór i lista elementów 2026',
    seoTitle: 'Jak przygotować ofertę na fotowoltaikę 2026',
    seoDescription: 'Wzór oferty PV dla instalatora: 10 sekcji, VAT 8% lub 23%, OSD, PSP, PME2 i opłacalność z jawnymi założeniami. Plus błędy z 67 prawdziwych ofert.',
    category: 'instalacje-pv',
    breadcrumbTopic: 'Dla firm PV',
    lead: 'Dobra oferta na fotowoltaikę ma 10 sekcji, od danych wejściowych po opłacalność z jawnymi założeniami. W 67 ofertach z października 2026 r. 57% cen nie mówiło, czy to brutto, czy netto.',
    updatedAt: '2026-10-14',
    readingTime: 14,
    featured: false,
    status: 'published',
    cover: 'offers',
    hero: { subtitle: 'Ofert z rynku bez informacji brutto czy netto', value: '57', unit: '%' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/instalacje-pv/jak-przygotowac-oferte-na-fotowoltaike.md`,
    related: [
      'program-do-wyceny-fotowoltaiki',
      'jak-porownac-oferty-na-instalacje-pv',
      'oferta-fotowoltaika-z-magazynem-co-sprawdzic',
      'czy-fotowoltaika-sie-oplaca',
    ],
  },
  // ===== Ceny dynamiczne (2026-10-06) =====
  {
    slug: 'sigenergy-pstryk-magazyn-taryfa-dynamiczna',
    title: 'Sigenergy i Pstryk: jak działa, ile kosztuje i kiedy się opłaca',
    seoTitle: 'Sigenergy i Pstryk: cena magazynu i czy się opłaca',
    seoDescription: 'Moduł SigenStor BAT 10.0 od ok. 10 130 zł, zestawy z montażem 41 do 52 tys. zł. Jak działa z Pstrykiem, ile kosztuje Connect i kiedy się nie opłaca.',
    category: 'magazyny',
    breadcrumbTopic: 'Ceny dynamiczne',
    lead: 'Magazyn Sigenergy z ceną dynamiczną Pstryk: jak naprawdę działa integracja, ceny zestawów w sklepach i ofertach, opłaty Pstryka, pobór własny i kiedy się nie opłaca.',
    updatedAt: '2026-10-14',
    readingTime: 15,
    featured: false,
    status: 'published',
    cover: 'battery-price',
    hero: { subtitle: 'Sigenergy z Pstrykiem · Pstryk Connect po 3 darmowych miesiącach', value: '30', unit: 'zł/mies.' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/magazyny/sigenergy-pstryk-magazyn-taryfa-dynamiczna.md`,
    related: [
      'taryfa-dynamiczna-czy-sie-oplaca',
      'pstryk-opinie-czy-cena-dynamiczna-sie-oplaca',
      'ile-kosztuje-magazyn-energii',
      'dotacja-na-magazyn-energii-pme2',
      'oferta-fotowoltaika-z-magazynem-co-sprawdzic',
    ],
    relatedProducts: REL_STORAGE,
  },
  {
    slug: 'pstryk-opinie-czy-cena-dynamiczna-sie-oplaca',
    title: 'Pstryk opinie: dla kogo cena dynamiczna prądu się opłaca',
    seoTitle: 'Pstryk opinie: ile kosztuje kWh i komu się opłaca',
    seoDescription: 'Pełna cena kWh u Pstryka z dystrybucją: od ok. 0,46 do 1,69 zł. Opłaty, haczyki umowy, wyniki użytkowników i dla jakiego domu cena dynamiczna jest tańsza.',
    category: 'instalacje-pv',
    breadcrumbTopic: 'Ceny dynamiczne',
    lead: 'Jak działa Pstryk, ile kosztuje kWh z dystrybucją, jak wypada na tle innych ofert dynamicznych i dla jakiego domu cena dynamiczna jest tańsza niż G11 albo G12w.',
    updatedAt: '2026-10-14',
    readingTime: 14,
    featured: false,
    status: 'published',
    cover: 'dynamic-price',
    hero: { subtitle: 'Pstryk · opłata za obsługę ponad cenę giełdową, netto', value: '0,08', unit: 'zł/kWh' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/instalacje-pv/pstryk-opinie-czy-cena-dynamiczna-sie-oplaca.md`,
    related: [
      'taryfa-dynamiczna-czy-sie-oplaca',
      'sigenergy-pstryk-magazyn-taryfa-dynamiczna',
      'jak-dobrac-magazyn-energii-do-fotowoltaiki',
      'ile-kosztuje-fotowoltaika-z-magazynem-energii',
    ],
    relatedProducts: REL_STORAGE,
  },

  {
    slug: 'taryfa-dynamiczna-czy-sie-oplaca',
    title: 'Taryfa dynamiczna: czy się opłaca? Porównanie z G11 i G12w',
    seoTitle: 'Taryfa dynamiczna: czy się opłaca? G11 i G12w',
    seoDescription: 'Ten sam dom w G11, G12w i cenie dynamicznej na cenach giełdowych z 12 miesięcy. Bez zmiany nawyków cena dynamiczna kosztuje ok. 700 zł rocznie więcej.',
    category: 'instalacje-pv',
    breadcrumbTopic: 'Ceny dynamiczne',
    lead: 'Dla większości domów taryfa dynamiczna się nie opłaca. Dom zużywający 4000 kWh rocznie zapłaciłby z ceną dynamiczną ok. 5 180 zł, o ok. 700 zł więcej niż w G11 i o ok. 900 zł więcej niż w G12w. Ma sens tylko przy przesuwaniu zużycia i dystrybucji G12w.',
    updatedAt: '2026-10-14',
    readingTime: 16,
    featured: false,
    status: 'published',
    cover: 'dynamic-price',
    hero: { subtitle: 'Dom 4000 kWh bez zmiany nawyków: cena dynamiczna wobec G11 (X 2025 do IX 2026)', value: '+700', unit: 'zł rocznie' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/instalacje-pv/taryfa-dynamiczna-czy-sie-oplaca.md`,
    related: [
      'czy-fotowoltaika-sie-oplaca',
      'pstryk-opinie-czy-cena-dynamiczna-sie-oplaca',
      'sigenergy-pstryk-magazyn-taryfa-dynamiczna',
      'jaki-magazyn-energii-do-falownika',
      'ile-kosztuje-magazyn-energii',
    ],
  },
  // ===== Ładowarki EV (wallboxy) =====
  {
    slug: 'wallbox-11-czy-22-kw',
    title: 'Wallbox 11 czy 22 kW? Sprawdź, ile naprawdę przyjmie Twoje auto',
    seoTitle: 'Wallbox 11 czy 22 kW? Tabela mocy dla 49 aut',
    seoDescription: 'Większość aut przyjmie maks. 11 kW, więc 22 kW nic nie przyspieszy. Auto 1-fazowe na wallboxie 11 kW ładuje się ok. 3,7 kW. Tabela dla 49 modeli aut.',
    category: 'ladowarki-ev',
    breadcrumbTopic: 'Dobór mocy wallboxa',
    lead: 'O mocy ładowania decyduje ładowarka pokładowa auta, nie wallbox. Kiedy 22 kW faktycznie coś daje, a kiedy 11 kW spowalnia auto jednofazowe. Z tabelą dla 49 modeli.',
    updatedAt: '2026-10-23',
    readingTime: 10,
    featured: false,
    status: 'published',
    cover: 'wallbox',
    hero: { subtitle: 'O mocy decyduje auto, nie ładowarka · pełna tabela 49 modeli', value: '11', unit: 'kW' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/ladowarki-ev/wallbox-11-czy-22-kw.md`,
    related: [
      'ladowanie-auta-z-fotowoltaiki',
      'jaki-wallbox-do-dacia-spring',
      'jaki-wallbox-do-tesla-model-y',
      'falownik-1-fazowy-czy-3-fazowy',
    ],
    relatedProducts: REL_WALLBOX,
  },
  {
    slug: 'ladowanie-auta-z-fotowoltaiki',
    title: 'Ładowanie auta z fotowoltaiki: co naprawdę jest potrzebne',
    seoTitle: 'Ładowanie auta z fotowoltaiki: tabela 13 wallboxów',
    seoDescription: 'Tryb solarny wymaga pomiaru przepływu energii, a moduł pomiarowy w większości wallboxów kupuje się osobno. Osprzęt i zgodność 13 modeli z falownikami.',
    category: 'ladowarki-ev',
    breadcrumbTopic: 'Wallbox i fotowoltaika',
    lead: 'Napis „tryb solarny" nie wystarczy: do ładowania nadwyżkami potrzebny jest pomiar przepływu energii, a moduł pomiarowy w większości wallboxów jest osobnym, płatnym akcesorium.',
    updatedAt: '2026-07-29',
    readingTime: 9,
    featured: false,
    status: 'published',
    cover: 'solar-ev',
    hero: { subtitle: 'Ładowanie z nadwyżek PV · potrzebny pomiar przepływu energii' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/ladowarki-ev/ladowanie-auta-z-fotowoltaiki.md`,
    related: [
      'wallbox-11-czy-22-kw',
      'jak-dobrac-magazyn-energii-do-fotowoltaiki',
      'falownik-1-fazowy-czy-3-fazowy',
    ],
    relatedProducts: REL_WALLBOX,
  },
  {
    slug: 'jaki-wallbox-do-tesla-model-3',
    title: 'Jaki wallbox do Tesla Model 3? Moc, czas ładowania i rekomendacja',
    seoTitle: 'Wallbox do Tesla Model 3: 11 kW, RWD pełna w 5,5 h',
    seoDescription: 'Model 3 przyjmuje 11 kW na trzech fazach w każdej wersji europejskiej, więc 22 kW nic nie da. Czasy ładowania RWD i Long Range, wallboxy od ok. 1320 zł.',
    category: 'ladowarki-ev',
    breadcrumbTopic: 'Dobór wallboxa do modelu',
    lead: 'Tesla Model 3 przyjmuje 11 kW na trzech fazach we wszystkich europejskich wersjach. Wallbox 11 kW wykorzysta auto w pełni, a dopłata do 22 kW nie skróci ładowania.',
    updatedAt: '2026-07-29',
    readingTime: 4,
    featured: false,
    status: 'published',
    cover: 'ev-model',
    hero: { subtitle: 'Ładowarka pokładowa 11 kW · 3 fazy · Type 2', value: '11', unit: 'kW' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/ladowarki-ev/jaki-wallbox-do-tesla-model-3.md`,
    related: ['wallbox-11-czy-22-kw', 'jaki-wallbox-do-tesla-model-y', 'ladowanie-auta-z-fotowoltaiki'],
    relatedProducts: REL_WALLBOX,
  },
  {
    slug: 'jaki-wallbox-do-tesla-model-y',
    title: 'Jaki wallbox do Tesla Model Y? Moc, czas ładowania i rekomendacja',
    seoTitle: 'Wallbox do Tesla Model Y: 11 kW, 22 kW nic nie da',
    seoDescription: 'Model Y ładuje się w domu maks. 11 kW na 3 fazach, więc wallbox 11 kW to dokładne dopasowanie: ok. 6 h do pełna w RWD. Przyłącze i wallboxy od ok. 1320 zł.',
    category: 'ladowarki-ev',
    breadcrumbTopic: 'Dobór wallboxa do modelu',
    lead: 'Tesla Model Y ma ładowarkę pokładową 11 kW trójfazową w każdej europejskiej wersji. Wallbox 11 kW to dokładne dopasowanie; 22 kW nic nie przyspieszy.',
    updatedAt: '2026-07-29',
    readingTime: 4,
    featured: false,
    status: 'published',
    cover: 'ev-model',
    hero: { subtitle: 'Ładowarka pokładowa 11 kW · 3 fazy · Type 2', value: '11', unit: 'kW' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/ladowarki-ev/jaki-wallbox-do-tesla-model-y.md`,
    related: ['wallbox-11-czy-22-kw', 'jaki-wallbox-do-tesla-model-3', 'ladowanie-auta-z-fotowoltaiki'],
    relatedProducts: REL_WALLBOX,
  },
  {
    slug: 'jaki-wallbox-do-skoda-enyaq',
    title: 'Jaki wallbox do Škoda Enyaq? Moc, czas ładowania i rekomendacja',
    seoTitle: 'Wallbox do Škoda Enyaq 2026: 11 kW czy 7,2 kW?',
    seoDescription: 'Enyaq ładuje się w domu 11 kW (77 kWh w ok. 7,5 h), ale wczesne 58 kWh miewały 7,2 kW. Elroq też ma 11 kW. Kabel czy gniazdo i wallboxy od ok. 1320 zł.',
    category: 'ladowarki-ev',
    breadcrumbTopic: 'Dobór wallboxa do modelu',
    lead: 'Škoda Enyaq ładuje się 11 kW na trzech fazach, ale wczesne egzemplarze 58 kWh miewały słabsze 7,2 kW. Rekomendacja i czasy ładowania z wyjątkami do sprawdzenia.',
    updatedAt: '2026-07-29',
    readingTime: 4,
    featured: false,
    status: 'published',
    cover: 'ev-model',
    hero: { subtitle: 'Ładowarka pokładowa 11 kW · 3 fazy · wyjątek 7,2 kW', value: '11', unit: 'kW' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/ladowarki-ev/jaki-wallbox-do-skoda-enyaq.md`,
    related: ['wallbox-11-czy-22-kw', 'jaki-wallbox-do-volkswagen-id4', 'ladowanie-auta-z-fotowoltaiki'],
    relatedProducts: REL_WALLBOX,
  },
  {
    slug: 'jaki-wallbox-do-volkswagen-id4',
    title: 'Jaki wallbox do Volkswagen ID.4? Moc, czas ładowania i rekomendacja',
    seoTitle: 'Wallbox do Volkswagen ID.4: 11 kW, pełna w 7,5 h',
    seoDescription: 'ID.4 przyjmuje 11 kW na 3 fazach, tak jak ID.3, ID.5 i ID.7. Wallbox 3-fazowy ładuje 77 kWh o 4 h szybciej niż 1-fazowy, a 22 kW nic nie doda.',
    category: 'ladowarki-ev',
    breadcrumbTopic: 'Dobór wallboxa do modelu',
    lead: 'Volkswagen ID.4 (platforma MEB) przyjmuje 11 kW na trzech fazach. Przy baterii 77 kWh wybór między wallboxem 1- a 3-fazowym to nawet cztery godziny różnicy.',
    updatedAt: '2026-07-29',
    readingTime: 4,
    featured: false,
    status: 'published',
    cover: 'ev-model',
    hero: { subtitle: 'Ładowarka pokładowa 11 kW · 3 fazy · Type 2', value: '11', unit: 'kW' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/ladowarki-ev/jaki-wallbox-do-volkswagen-id4.md`,
    related: ['wallbox-11-czy-22-kw', 'jaki-wallbox-do-skoda-enyaq', 'ladowanie-auta-z-fotowoltaiki'],
    relatedProducts: REL_WALLBOX,
  },
  {
    slug: 'jaki-wallbox-do-kia-ev6',
    title: 'Jaki wallbox do Kia EV6? Moc, czas ładowania i rekomendacja',
    seoTitle: 'Wallbox do Kia EV6: 11 kW, a 800 V tylko na DC',
    seoDescription: 'Kia EV6 ładuje się w domu maks. 11 kW, a 800 V przyspiesza tylko DC. Bateria 84 kWh w ok. 8,5 h, z wallboxa 1-fazowego ponad 12 h. Polecane modele.',
    category: 'ladowarki-ev',
    breadcrumbTopic: 'Dobór wallboxa do modelu',
    lead: 'Kia EV6 imponuje ładowaniem DC, ale w domu liczy się ładowarka pokładowa i jej 11 kW na trzech fazach. Architektura 800 V nie zmienia tu nic.',
    updatedAt: '2026-07-29',
    readingTime: 4,
    featured: false,
    status: 'published',
    cover: 'ev-model',
    hero: { subtitle: 'Ładowarka pokładowa 11 kW · 3 fazy · 800 V tylko dla DC', value: '11', unit: 'kW' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/ladowarki-ev/jaki-wallbox-do-kia-ev6.md`,
    related: ['wallbox-11-czy-22-kw', 'jaki-wallbox-do-hyundai-ioniq-5', 'ladowanie-auta-z-fotowoltaiki'],
    relatedProducts: REL_WALLBOX,
  },
  {
    slug: 'jaki-wallbox-do-hyundai-ioniq-5',
    title: 'Jaki wallbox do Hyundai Ioniq 5? Moc, czas ładowania i rekomendacja',
    seoTitle: 'Wallbox do Hyundai Ioniq 5: 11 kW, 84 kWh w 8,5 h',
    seoDescription: 'Ioniq 5 (i Ioniq 6) ładuje się w domu 11 kW na 3 fazach, więc 22 kW nic nie da. Czasy dla baterii 58, 77,4 i 84 kWh, przyłącze i wallboxy od ok. 1320 zł.',
    category: 'ladowarki-ev',
    breadcrumbTopic: 'Dobór wallboxa do modelu',
    lead: 'Hyundai Ioniq 5 (platforma E-GMP, 800 V) ładuje się w domu prądem przemiennym z mocą 11 kW na trzech fazach. Wallbox 22 kW nie da żadnego zysku.',
    updatedAt: '2026-07-29',
    readingTime: 4,
    featured: false,
    status: 'published',
    cover: 'ev-model',
    hero: { subtitle: 'Ładowarka pokładowa 11 kW · 3 fazy · 800 V tylko dla DC', value: '11', unit: 'kW' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/ladowarki-ev/jaki-wallbox-do-hyundai-ioniq-5.md`,
    related: ['wallbox-11-czy-22-kw', 'jaki-wallbox-do-kia-ev6', 'ladowanie-auta-z-fotowoltaiki'],
    relatedProducts: REL_WALLBOX,
  },
  {
    slug: 'jaki-wallbox-do-toyota-bz4x',
    title: 'Jaki wallbox do Toyota bZ4X? Moc, czas ładowania i rekomendacja',
    seoTitle: 'Wallbox do Toyota bZ4X: 11 kW, wczesne 6,6 kW',
    seoDescription: 'Aktualna bZ4X przyjmuje 11 kW (pełna w ok. 6,5 h), ale wczesne roczniki tylko 6,6 do 7 kW i wtedy wystarczy tańszy wallbox 1-fazowy. Jak to sprawdzić.',
    category: 'ladowarki-ev',
    breadcrumbTopic: 'Dobór wallboxa do modelu',
    lead: 'Toyota bZ4X w aktualnych wersjach przyjmuje 11 kW na trzech fazach, ale wczesne roczniki miały słabsze 6,6–7 kW. Przy używanym aucie potwierdź moc OBC przed zakupem wallboxa.',
    updatedAt: '2026-07-29',
    readingTime: 4,
    featured: false,
    status: 'published',
    cover: 'ev-model',
    hero: { subtitle: 'Ładowarka pokładowa 11 kW · wczesne roczniki 6,6–7 kW', value: '11', unit: 'kW' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/ladowarki-ev/jaki-wallbox-do-toyota-bz4x.md`,
    related: ['wallbox-11-czy-22-kw', 'ladowanie-auta-z-fotowoltaiki', 'falownik-1-fazowy-czy-3-fazowy'],
    relatedProducts: REL_WALLBOX,
  },
  {
    slug: 'jaki-wallbox-do-bmw-ix1',
    title: 'Jaki wallbox do BMW iX1? Moc, czas ładowania i rekomendacja',
    seoTitle: 'Wallbox do BMW iX1: 11 czy 22 kW? Sprawdź wersję',
    seoDescription: 'iX1 ma standardowo 11 kW, ale z opcją 22 kW wallbox 22 kW skraca ładowanie z 6,5 do 3,5 h. Jak sprawdzić wersję auta i czy przyłącze udźwignie 32 A.',
    category: 'ladowarki-ev',
    breadcrumbTopic: 'Dobór wallboxa do modelu',
    lead: 'BMW iX1 ma standardowo 11 kW na trzech fazach, ale opcjonalnie 22 kW za dopłatą. To jeden z niewielu przypadków, gdzie mocniejszy wallbox realnie skraca ładowanie. Najpierw ustal wersję OBC.',
    updatedAt: '2026-07-29',
    readingTime: 4,
    featured: false,
    status: 'published',
    cover: 'ev-model',
    hero: { subtitle: 'Standard 11 kW · opcja 22 kW za dopłatą · sprawdź wersję', value: '11', unit: 'kW' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/ladowarki-ev/jaki-wallbox-do-bmw-ix1.md`,
    related: ['wallbox-11-czy-22-kw', 'jaki-wallbox-do-volvo-ex30', 'ladowanie-auta-z-fotowoltaiki'],
    relatedProducts: REL_WALLBOX,
  },
  {
    slug: 'jaki-wallbox-do-volvo-ex30',
    title: 'Jaki wallbox do Volvo EX30? Moc, czas ładowania i rekomendacja',
    seoTitle: 'Wallbox do Volvo EX30: kiedy 22 kW skraca o połowę',
    seoDescription: 'EX30 ładuje się 11 kW (ok. 7 h do pełna), a z opcją 22 kW w ok. 3,5 h. Jak sprawdzić, którą wersję masz, i czy przyłącze udźwignie 32 A na fazę.',
    category: 'ladowarki-ev',
    breadcrumbTopic: 'Dobór wallboxa do modelu',
    lead: 'Volvo EX30 ładuje się 11 kW na trzech fazach, a w części wersji dostępna jest opcja 22 kW. Jeśli Twój egzemplarz ją ma, wallbox 22 kW skraca ładowanie o połowę.',
    updatedAt: '2026-07-29',
    readingTime: 4,
    featured: false,
    status: 'published',
    cover: 'ev-model',
    hero: { subtitle: 'Standard 11 kW · opcja 22 kW w części wersji', value: '11', unit: 'kW' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/ladowarki-ev/jaki-wallbox-do-volvo-ex30.md`,
    related: ['wallbox-11-czy-22-kw', 'jaki-wallbox-do-bmw-ix1', 'ladowanie-auta-z-fotowoltaiki'],
    relatedProducts: REL_WALLBOX,
  },
  {
    slug: 'jaki-wallbox-do-dacia-spring',
    title: 'Jaki wallbox do Dacia Spring? Uwaga na pułapkę wallboxa 11 kW',
    seoTitle: 'Wallbox do Dacia Spring: 7,4 kW, a nie 11 kW',
    seoDescription: 'Spring ładuje się na 1 fazie (6,6 kW), więc wallbox 11 kW da mu tylko ok. 3,7 kW i 8 h zamiast 4,5 h. Wybierz 1-fazowy 7,4 kW albo 3-fazowy 22 kW.',
    category: 'ladowarki-ev',
    breadcrumbTopic: 'Dobór wallboxa do modelu',
    lead: 'Dacia Spring jest jednofazowa (6,6 kW, od 2024 roku 7 kW), więc popularny wallbox 11 kW naładuje ją zaledwie ok. 3,7 kW, prawie dwa razy wolniej. Wybierz 1-fazowy 7,4 kW albo 3-fazowy 22 kW.',
    updatedAt: '2026-10-23',
    readingTime: 5,
    featured: false,
    status: 'published',
    cover: 'ev-model',
    hero: { subtitle: 'Auto jednofazowe 6,6 kW · nie kupuj wallboxa 11 kW', value: '6,6', unit: 'kW' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/ladowarki-ev/jaki-wallbox-do-dacia-spring.md`,
    related: ['wallbox-11-czy-22-kw', 'ladowanie-auta-z-fotowoltaiki', 'falownik-1-fazowy-czy-3-fazowy'],
    relatedProducts: REL_WALLBOX,
  },

  // ===== Moduły fotowoltaiczne =====
  {
    slug: 'jak-dobrac-panel-fotowoltaiczny-do-rozbudowy-instalacji',
    title: 'Jak dobrać panel fotowoltaiczny do rozbudowy istniejącej instalacji?',
    seoTitle: 'Jak dobrać panel do rozbudowy instalacji PV?',
    seoDescription: 'Sama moc Wp nie wystarczy. Przy dokładaniu paneli liczą się prąd i napięcie (zwłaszcza we wspólnym stringu), wymiary i technologia. Dobór w 6 krokach.',
    category: 'pv',
    breadcrumbTopic: 'Rozbudowa instalacji',
    lead: 'Sama moc Wp nie wystarcza. Co porównać przy dokładaniu paneli: prąd i napięcie (zależnie od tego, czy string jest wspólny), wymiary, technologia i formalności u operatora.',
    updatedAt: '2026-08-05',
    readingTime: 12,
    featured: false,
    status: 'published',
    cover: 'panel-match',
    hero: { subtitle: 'Dobór modułu do rozbudowy · decyduje prąd i napięcie, nie sama moc' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/pv/jak-dobrac-panel-fotowoltaiczny-do-rozbudowy-instalacji.md`,
    related: [
      'ile-paneli-w-stringu',
      'czy-mozna-mieszac-rozne-modele-paneli-fotowoltaicznych',
      'falownik-1-fazowy-czy-3-fazowy',
      'jak-porownac-oferty-na-instalacje-pv',
    ],
    relatedProducts: REL_PANELS,
  },
  {
    slug: 'czy-mozna-mieszac-rozne-modele-paneli-fotowoltaicznych',
    title: 'Czy można mieszać różne modele paneli fotowoltaicznych w jednej instalacji?',
    seoTitle: 'Czy można mieszać różne panele fotowoltaiczne?',
    seoDescription: 'Tak, ale o ryzyku decyduje sposób połączenia, nie marka. Od osobnego falownika lub MPPT po najryzykowniejsze: różne moduły w jednym stringu. Checklista.',
    category: 'pv',
    breadcrumbTopic: 'Rozbudowa instalacji',
    lead: 'Można, ale ryzyko zależy od sposobu połączenia, nie od marki. Od najbezpieczniejszego wariantu (osobny falownik) po najbardziej ryzykowny (różne moduły w jednym stringu).',
    updatedAt: '2026-08-05',
    readingTime: 12,
    featured: false,
    status: 'published',
    cover: 'panel-mix',
    hero: { subtitle: 'Mieszanie modułów · o ryzyku decyduje połączenie, nie producent' },
    mdPath: `${process.env.PUBLIC_URL || ''}/knowledge-base/pv/czy-mozna-mieszac-rozne-modele-paneli-fotowoltaicznych.md`,
    related: [
      'dwa-stringi-na-jednym-mppt',
      'jak-dobrac-panel-fotowoltaiczny-do-rozbudowy-instalacji',
      'falownik-1-fazowy-czy-3-fazowy',
      'jak-porownac-oferty-na-instalacje-pv',
    ],
    relatedProducts: REL_PANELS,
  },
]

// Publikowane w produkcji. Drafty pokazujemy tylko w dev.
export const isDev = process.env.NODE_ENV !== 'production'

export const visibleArticles = () =>
  KB_ARTICLES.filter((a) => a.status === 'published' || isDev)

export const getArticle = (slug) => KB_ARTICLES.find((a) => a.slug === slug)

export const categoryLabel = (key) => KB_CATEGORIES.find((c) => c.key === key)?.label || key
